var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43131 0.762207H23.5036C23.8288 0.762207 24.1407 0.891399 24.3706 1.12136C24.6006 1.35133 24.7298 1.66322 24.7298 1.98844V21.6082C24.7298 21.9334 24.6006 22.2453 24.3706 22.4753C24.1407 22.7053 23.8288 22.8344 23.5036 22.8344H1.43131C1.1061 22.8344 0.794198 22.7053 0.564234 22.4753C0.33427 22.2453 0.205078 21.9334 0.205078 21.6082V1.98844C0.205078 1.66322 0.33427 1.35133 0.564234 1.12136C0.794198 0.891399 1.1061 0.762207 1.43131 0.762207ZM22.2773 5.95899L12.5557 14.6653L2.65755 5.93202V20.382H22.2773V5.95899ZM3.28416 3.21468L12.5422 11.3839L21.6667 3.21468H3.28416Z",
    fill: "#828893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5a74d04d43e542e5f8e7b6f0b0795956.svg";
export { ForwardRef as ReactComponent };